/**
 * Checkout shipping address form schema
 * Based on existing custom-checkout-shipping-address module
 */

import { z } from 'zod';
import { getAddressSchema } from '../address';

/**
 * Get checkout shipping address schema with locale-specific validation
 */
export const getCheckoutShippingAddressSchema = (locale?: string, countryCode?: string) => {
    return getAddressSchema(locale, countryCode);
};

// Type inference
export type CheckoutShippingAddressFormData = z.infer<ReturnType<typeof getCheckoutShippingAddressSchema>>;
